import Api from '@/services/Api'

export default {
  convertPdfToBase64(query) {
    return Api().get('convert/convertPdfToBase64', {
      params: query
    })
  },

}